/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {SegmentedButtonOptionModel} from '../../../shared/segemented-button/segmented-button-option.model';
import {PeriodViewTabsEnum} from '../data/period-view-tabs.enum';
import {SegmentedButtonDisplayModeEnum} from '../../../shared/segemented-button/segmented-button-display-mode.enum';

export const periodViewTabsConfiguration: {
    tabs: SegmentedButtonOptionModel<PeriodViewTabsEnum>[];
    defaultTab: PeriodViewTabsEnum;
} = {
    tabs: [
        {
            label: 'Periods',
            value: PeriodViewTabsEnum.PERIODS,
            isSelected: true,
            displayMode: SegmentedButtonDisplayModeEnum.BASE,
            inlineStyle: {'width': '115px'}
        }, {
            label: 'Bundles',
            value: PeriodViewTabsEnum.BUNDLES,
            isSelected: false,
            displayMode: SegmentedButtonDisplayModeEnum.BASE,
            inlineStyle: {'width': '115px'}
        },
        {
            label: 'Settlements',
            value: PeriodViewTabsEnum.SETTLEMENTS,
            isSelected: false,
            displayMode: SegmentedButtonDisplayModeEnum.BASE,
            inlineStyle: {'width': '115px'}
        }
    ],
    defaultTab: PeriodViewTabsEnum.PERIODS
};
